import { Pipe, PipeTransform } from '@angular/core';

interface IValidation {
  validationMsgHtml: {
    minField: string;
    maxField: string;
  };
  alertMsgHtml: {
    content: string;
    color: string;
  };
}
@Pipe({
    name: 'inputBoxValidationPipe',
    standalone: true,
})
export class InputBoxValidationPipePipe implements PipeTransform {
  transform(
    [inputType = '', legalMinInput = '', legalMaxInput = '']: any[],
    validateFor: string = ''
  ): IValidation {

    let result: IValidation = {
      validationMsgHtml: {
        minField: '',
        maxField: '',
      },
      alertMsgHtml: {
        content: '',
        color: '',
      },
    };

    const msg = {
      success: `${
        legalMinInput == null ||
        legalMaxInput == null ||
        legalMinInput == '' ||
        legalMaxInput == ''
          ? ``
          : `Supplier shall be able to choose an input value ${
              legalMinInput == legalMaxInput
                ? `of ${legalMinInput}`
                : `between ${legalMinInput} and ${legalMaxInput}`
            }`
      }`,
      illegal: {
        minMaxValues: `The legally allowed minimum value should be less than that of the the legally allowed maximum`,
        minMaxLimits: {
          minField: `<b>MIN</b> value should be less than the <b>MAX</b> value (or)`,
          maxField: `<b>MAX</b> value should be greater than the <b>MIN</b> value`,
        },
      },
      error: {
        naturalNumber: `Choose a number between <b>0</b> and <b>999</b>`,
        integerNumber: `Choose a number between <b>-999</b> and <b>999</b>`,
      },
      empty: '',
    };

    // SET-01

    const isNaturalNumberTypeSelected: boolean =
      String(inputType).toLowerCase() === 'number';
    const isIntegerTypeSelected: boolean =
      String(inputType).toLowerCase() === 'number2';

    const isValidationNeededForMinInput =
      String(validateFor).toLowerCase() === 'legal_min';
    const isValidationNeededForMaxInput =
      String(validateFor).toLowerCase() === 'legal_max';
    const isValidationNeededForAlert =
      String(validateFor).toLowerCase() === 'alert';

    const isInputNaturalNumberLegalMin =
      isNaturalNumberTypeSelected &&
      (String(legalMinInput) !== '' || String(legalMinInput) != 'null') &&
      0 <= Number(legalMinInput) &&
      Number(legalMinInput) <= 999;

    const isInputNaturalNumberLegalMax =
      isNaturalNumberTypeSelected &&
      (String(legalMaxInput) !== '' || String(legalMaxInput) != 'null') &&
      0 <= Number(legalMaxInput) &&
      Number(legalMaxInput) <= 999;

    const isInputIntegerLegalMin: boolean =
      isIntegerTypeSelected &&
      (String(legalMinInput) !== '' || String(legalMinInput) != 'null') &&
      -999 <= Number(legalMinInput) &&
      Number(legalMinInput) <= 999;

    const isInputIntegerLegalMax: boolean =
      isIntegerTypeSelected &&
      (String(legalMaxInput) !== '' || String(legalMaxInput) != 'null') &&
      -999 <= Number(legalMaxInput) &&
      Number(legalMaxInput) <= 999;

    const letItBeAnyTypeSelection =
      isNaturalNumberTypeSelected || isIntegerTypeSelected;

    const letItBeAnyElementValidation =
      isValidationNeededForAlert ||
      isValidationNeededForMaxInput ||
      isValidationNeededForMinInput;

    const rangeValidationsSuccessCondition: boolean =
      letItBeAnyElementValidation &&
      letItBeAnyTypeSelection &&
      ((isInputNaturalNumberLegalMin && isInputNaturalNumberLegalMax) ||
        (isInputIntegerLegalMin && isInputIntegerLegalMax));

    const illegalMinOverMaxCondition: boolean =
      rangeValidationsSuccessCondition && legalMinInput > legalMaxInput;

    const naturalNumberErrorCondition =
      letItBeAnyElementValidation &&
      isNaturalNumberTypeSelected &&
      (!isInputNaturalNumberLegalMin || !isInputIntegerLegalMax);

    const integerErrorCondition =
      isIntegerTypeSelected &&
      letItBeAnyElementValidation &&
      (!isInputIntegerLegalMin || !isInputIntegerLegalMax);

    const legalValidationsSuccessCondition =
      rangeValidationsSuccessCondition && !illegalMinOverMaxCondition;

    const legalValidationSuccess = {
      validationMsgHtml: {
        minField: msg.empty,
        maxField: msg.empty,
      },
      alertMsgHtml: {
        content: msg.success,
        color: 'success',
      },
    };

    const illegalMinOverMax = {
      validationMsgHtml: {
        minField:
          letItBeAnyTypeSelection && isValidationNeededForMinInput
            ? msg.illegal.minMaxLimits.minField
            : '',
        maxField:
          letItBeAnyTypeSelection && isValidationNeededForMaxInput
            ? msg.illegal.minMaxLimits.maxField
            : '',
      },
      alertMsgHtml: {
        content: msg.illegal.minMaxValues,
        color: 'warning',
      },
    };

    const integerError = {
      validationMsgHtml: {
        minField: isInputIntegerLegalMin ? '' : msg.error.integerNumber,
        maxField: isInputIntegerLegalMax ? '' : msg.error.integerNumber,
      },
      alertMsgHtml: {
        content: msg.error.integerNumber,
        color: 'danger',
      },
    };
    const naturalNumberError = {
      validationMsgHtml: {
        minField: isInputNaturalNumberLegalMin ? '' : msg.error.naturalNumber,
        maxField: isInputNaturalNumberLegalMax ? '' : msg.error.naturalNumber,
      },
      alertMsgHtml: {
        content: msg.error.naturalNumber,
        color: 'danger',
      },
    };

    if (inputType && (legalMaxInput || legalMinInput)) {
      if (legalValidationsSuccessCondition) {
        result = legalValidationSuccess;
      } else if (illegalMinOverMaxCondition) {
        result = illegalMinOverMax;
      } else if (naturalNumberErrorCondition) {
        result = naturalNumberError;
      } else if (integerErrorCondition) {
        result = integerError;
      }
    } else {
      result = result;
    }

    return result;
  }
}
